import axiosFrame from 'axios'
import _this from '../main'
/* eslint-disable */

const configApi = (window.apiConfig && window.apiConfig[window.env + 'Api']) || []
let cancelToken = axiosFrame.CancelToken

window.baseUrlList = configApi
function paramsToUrl (url, params) {
  if (!params) return url;
  for (let key in params) {
    if (params[key] && params[key] !== "undefined") {
      if (url.indexOf("?") > -1) {
        url += "&" + "" + key + "=" + params[key] || "" + "";
      } else {
        url += "?" + "" + key + "=" + params[key] || "" + "";
      }
    }
  }
  return url;
}

function requireData (url, params, type, index, cancel) {
  if (!url) return false;
  url = configApi[index] + url

  // 拦截axios请求前后并做相关处理
  let $http = ajax(type);

  let requestByMethod = (method) => {
    if (method.toLowerCase() === "get") {
      url = paramsToUrl(url, params);
      return new Promise((resolve, reject) => {
        $http.get(url, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      });
    } else if (method.toLowerCase() === "post") {
      return new Promise((resolve, reject) => {
        $http.post(url, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      });
    } else if (method.toLowerCase() === "put") {
      return new Promise((resolve, reject) => {
        $http.put(url, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      });
    } else if (method.toLowerCase() === "delete") {
      return new Promise((resolve, reject) => {
        $http.delete(url, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      });
    }
  }

  if (typeof type === 'string') {
    return requestByMethod(type)
  } else if (typeof type === 'object') {
    return requestByMethod(type.method || 'post')
  } else if (typeof type === 'undefined') {
    return requestByMethod('post')
  }
}

const ajax = (type) => {
  let currentSystemName = _this.$route.path.split('/')[1] || ''
  // 默认Ajax配置
  let $http = axiosFrame.create({
    headers: { 'x-auth-token': localStorage.getItem("art-x-auth-token"), systemName: currentSystemName },
    timeout: 5 * 60 * 1000,
    cancelToken: new cancelToken((c)=>{
    })
  });
  // 拦截request
  $http.interceptors.request.use(
    function (config) {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";

      if (localStorage.getItem("art-x-auth-token")) {
        config.headers.common["x-auth-token"] = localStorage.getItem("art-x-auth-token");
      }

      if (typeof type === 'object' && type.headers && type.headers['Content-Type']) {
        if (config.method === 'get') {
          //  给data赋值以绕过if判断
          config.data = true
        }
        config.headers["Content-Type"] = type.headers['Content-Type'];
      }

      if (config.method === "post" && config.headers["Content-Type"] === "application/x-www-form-urlencoded") {
        config.headers["Content-Type"] = "application/json";
      }

      if (config.method === "put") {
        config.headers["Content-Type"] = "application/json";
      }

      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  // 拦截response
  $http.interceptors.response.use(
    function (response) {
      let code = Number(response.data.code);
      if (code === 403) { //  掉线
        localStorage.removeItem('art-userInfo')
        localStorage.removeItem('art-x-auth-token')
        localStorage.removeItem('art-i18n_language')
        // if (_this.$route.path === '/devOpsManage/dueDiligence') {
        //   _this.$router.push({ path: '/login',query: {
        //     path: _this.$route.path,
        //     query: JSON.stringify(_this.$route.query)
        //   }})
        // } else {
        //   _this.$router.push({ path: '/login' })
        // }
        if (_this.$route.path === '/login') {
          _this.$router.push({ path: '/login' })
         
        } else {  
          _this.$router.push({ path: '/login',query: {
            path: _this.$route.path,
            query: JSON.stringify(_this.$route.query)
          }})
        }
       
      } else if (code !== 0) { // 报错处理
        _this.$message.error(response.data.msg)
      }
      return response.data;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  return $http;
};

export default {
  install (Vue, options) {
    configApi.forEach((item, index) => {
      Vue.prototype["reqServiceOf" + index] = function (url, params, type, cancel) {
        return requireData.call(this, url, params, type, index, cancel);
      };
    });
  }
};



// WEBPACK FOOTER //
// ./src/global/apiBaseUrlConfig.js